import logo from './imgs/lgo.jpg';

const tagList = ['SALE', 'BEST', 'MD', 'SOLDOUT', '판매대기'];
export const imgs = { logo };

export default {
  tagList,
};
